import React from 'react';
import { formatNumber } from '../../../../app-actions';
import './floating-information.css';

const FloatingInformation = (props) => {
  const {
    authorableContent: {
      costSummary,
      inclGST,
      current,
      future,
      costDevice,
      totalCostReductionText,
    },
    estimatedTotalNewMonthlyCost: {
      totalCost,
      dataInclusion,
    },
    estimatedTotalCurrentMonthlyCost: {
      totalCost: currentTotalCost,
      dataInclusion: currentDataInclusion,
    },
    currentMontlyCost,
    contractTerm,
    rrpCostValue,
    avgPhoneCost,
    newDeviceCount,
    newMontlyCost,
    currentTab,
  } = props;
  return (
    <div className="floating-info">
      <div className="row">
        <div className="col-12 header">
          <h2 className="header-text">{costSummary}</h2>
          <h6 className="header-body">{inclGST}</h6>
        </div>
        <div className="col-12 body">
          <div className="data-points">
            <div className="row">
              <div className="col-5 border-current">
                <p className="data header">{current}</p>
                <p className="data body">${formatNumber(currentTotalCost)}/mth</p>
                <p className="data body">{formatNumber(currentDataInclusion)}GB</p>
              </div>
              <div className="col-5 border-future">
                <p className="data header">{future}</p>
                <p className="data body">${formatNumber(totalCost)}/mth</p>
                <p className="data body">{formatNumber(dataInclusion)}GB</p>
              </div>
            </div>
          </div>
          {currentTab === 'tab4' &&
            <React.Fragment>
              <div className="data-points">
                <p className="data header">{costDevice}</p>
                <p className="data body">${formatNumber((currentMontlyCost * contractTerm)
                  + (rrpCostValue * contractTerm * newDeviceCount), 2)}</p>
              </div>
              <div className="data-points">
                <p className="data header">{totalCostReductionText}</p>
                <p className="data body">${formatNumber(((currentMontlyCost * contractTerm)
                  + (rrpCostValue * contractTerm * newDeviceCount)) - ((newMontlyCost * contractTerm)
                    + (avgPhoneCost * contractTerm * newDeviceCount)), 2)}</p>
              </div>
            </React.Fragment>
          }
        </div>

      </div>
    </div>
  );
};

export default FloatingInformation;
